import { DATIQ_MODAL_BUTTON_ID, IDatiqModal } from '../models';
import { Store } from '@ngrx/store';
import {
    DatiqAnalyticsInputInteraction,
    IDatiqAnalyticsEvent,
    IDatiqAnalyticsEventInputInfo,
} from '@dat/datiq-core/models';

import { DatiqModalActions } from '../../store';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class DatiqModalEventsService {
    constructor(private _store: Store) {}

    clickCloseButton(settings: IDatiqModal): void {
        this._store.dispatch(
            DatiqModalActions.clickedClosedButton(
                this.getAnalyticsButtonClosedButton(settings)
            )
        );
    }

    getAnalyticsButtonClosedButton(
        settings: IDatiqModal
    ): IDatiqAnalyticsEvent {
        const inputInfo: IDatiqAnalyticsEventInputInfo = {
            inputId: DATIQ_MODAL_BUTTON_ID(settings.id),
            interaction: DatiqAnalyticsInputInteraction.Click,
            props: this.getProps(settings),
        };

        return {
            eventName: DatiqModalActions.clickedCloseButtonName,
            inputInfo,
        };
    }
    opened(settings: IDatiqModal): void {
        this._store.dispatch(
            DatiqModalActions.opened(this.getAnalyticsModalOpened(settings))
        );
    }

    getAnalyticsModalOpened(settings: IDatiqModal): IDatiqAnalyticsEvent {
        const inputInfo: IDatiqAnalyticsEventInputInfo = {
            inputId: settings.id,
            interaction: DatiqAnalyticsInputInteraction.Open,
            settings,
            props: this.getProps(settings),
        };

        return {
            eventName: DatiqModalActions.openedName,
            inputInfo,
        };
    }

    getProps(settings: IDatiqModal): unknown {
        return settings?.props ?? {};
    }
}
